/* global Swiper */
(function () {
  'use strict';

  var STAR_SVG =
    '<svg class="ugc-r__star" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5l2.4 5.3 5.8.8-4.2 4.1 1 5.8L12 15.2 6 17.5l1-5.8L2.8 7.6l5.8-.8L12 1.5z"/></svg>';
  var STAR_SVG_OFF =
    '<svg class="ugc-r__star ugc-r__star--off" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5l2.4 5.3 5.8.8-4.2 4.1 1 5.8L12 15.2 6 17.5l1-5.8L2.8 7.6l5.8-.8L12 1.5z"/></svg>';

  function elStars(n) {
    n = Math.min(5, Math.max(0, parseInt(n, 10) || 0));
    var html = '';
    for (var i = 0; i < 5; i += 1) {
      html += i < n ? STAR_SVG : STAR_SVG_OFF;
    }
    return '<span class="ugc-r__star-row" aria-label="' + n + ' of 5">' + html + '</span>';
  }

  function escapeAttr(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function initialFromName(name) {
    if (!name) return '•';
    return String(name).trim().charAt(0).toUpperCase() || '•';
  }

  function mount(section) {
    var elScript = section.querySelector('[data-ugc-reviews-json]');
    var url = (section.getAttribute('data-json-url') || '').trim();
    var minRating = parseInt(section.getAttribute('data-min-rating') || '4', 10) || 4;
    var effect = section.getAttribute('data-swiper-effect') || 'slide';
    var slideSpeed = parseInt(section.getAttribute('data-slide-speed') || '500', 10) || 500;
    var wrapper = section.querySelector('.ugc-r__swiper .swiper-wrapper');
    if (!wrapper) return;

    var reviews = [];

    function renderPanel(review) {
      var pName = section.querySelector('[data-panel-name]');
      var pText = section.querySelector('[data-panel-text]');
      var pAv = section.querySelector('[data-panel-avatar-initial]');
      var pStars = section.querySelector('[data-panel-stars]');
      if (!pName || !review) return;
      pName.textContent = review.name || '';
      if (pText) pText.textContent = review.text || '';
      if (pAv) pAv.textContent = review.initial || initialFromName(review.name);
      if (pStars) pStars.innerHTML = elStars(review.rating);
    }

    function onActive(idx) {
      if (idx >= 0 && idx < reviews.length) {
        renderPanel(reviews[idx]);
        section.setAttribute('data-active-review', String(idx + 1));
      }
    }

    function runSwiper() {
      if (typeof Swiper === 'undefined' || !reviews.length) return;
      var n = reviews.length;
      var swiperEl = section.querySelector('.ugc-r__swiper');
      if (!swiperEl) return;
      var startIndex = n > 1 ? Math.floor(n / 2) : 0;
      var shouldLoop = n > 1;
      if (n === 1) {
        section.classList.add('ugc-r--one-slide');
      }
      var navNext = section.querySelector('.ugc-r__nav--next');
      var navPrev = section.querySelector('.ugc-r__nav--prev');
      if (n < 2 && navNext && navPrev) {
        navNext.style.display = 'none';
        navPrev.style.display = 'none';
      }

      var base = {
        speed: slideSpeed,
        watchSlidesProgress: true,
        grabCursor: n > 1,
        /* if true, Swiper hides nav when all slides “fit” — with few reviews + wide slidesPerView, arrows do nothing / look dead */
        watchOverflow: false,
        loop: shouldLoop,
        centeredSlides: true,
        centeredSlidesBounds: false,
        initialSlide: startIndex,
        navigation: n > 1
          ? {
              nextEl: navNext,
              prevEl: navPrev,
            }
          : false,
        on: {
          slideChange: function () {
            onActive(this.realIndex);
          },
        },
      };

      function forceCenter(swiper) {
        if (!swiper) return;
        var apply = function () {
          if (swiper.params.loop && n > 1) {
            swiper.slideToLoop(startIndex, 0, false);
          } else {
            swiper.slideTo(startIndex, 0, false);
          }
          swiper.updateSlidesClasses();
          onActive(swiper.realIndex);
        };
        requestAnimationFrame(function () {
          requestAnimationFrame(apply);
        });
      }

      /* Match reference slider behavior: 3 desktop, 2 tablet, 1 mobile, centered */
      var sMobile = n >= 2 ? 1.1 : 1;

      if (effect === 'coverflow') {
        // eslint-disable-next-line no-new
        var coverflowSwiper = new Swiper(
          swiperEl,
          Object.assign(
            {
              effect: 'coverflow',
              slidesPerView: 'auto',
              spaceBetween: 12,
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 120,
                modifier: 1,
                slideShadows: false,
              },
              breakpoints: {
                575: { centeredSlides: true, slidesPerView: sMobile, spaceBetween: 12 },
                768: { centeredSlides: true, slidesPerView: 'auto', spaceBetween: 16 },
                1024: { centeredSlides: true, slidesPerView: 'auto', spaceBetween: 20 },
              },
            },
            base
          )
        );
        forceCenter(coverflowSwiper);
      } else {
        // eslint-disable-next-line no-new
        var slideSwiper = new Swiper(
          swiperEl,
          Object.assign(
            {
              effect: 'slide',
              slidesPerView: 'auto',
              spaceBetween: 12,
              breakpoints: {
                575: { centeredSlides: true, slidesPerView: sMobile, spaceBetween: 12 },
                768: { centeredSlides: true, slidesPerView: 'auto', spaceBetween: 16 },
                1024: { centeredSlides: true, slidesPerView: 'auto', spaceBetween: 20 },
              },
            },
            base
          )
        );
        forceCenter(slideSwiper);
      }
    }

    if (url) {
      fetch(url, { headers: { Accept: 'application/json' }, mode: 'cors' })
        .then(function (res) {
          if (!res.ok) throw new Error('ugc-r');
          return res.json();
        })
        .then(function (data) {
          var list = (data && data.reviews) || (Array.isArray(data) && data) || [];
          if (!list.length) return;
          var filtered = list
            .filter(function (r) {
              return (parseInt(r.rating, 10) || 0) >= minRating;
            })
            .sort(function (a, b) {
              return (parseInt(b.rating, 10) || 0) - (parseInt(a.rating, 10) || 0);
            });
          reviews = filtered
            .map(function (r) {
              return {
                name: r.name || r.author || '',
                text: r.text || r.body || '',
                rating: Math.min(5, Math.max(1, parseInt(r.rating, 10) || 5)),
                image: r.image,
                initial: (r.initial || initialFromName(r.name || '')).toString().charAt(0) || '•',
              };
            })
            .filter(function (r) {
              return !!r.image;
            });
          if (!reviews.length) return;
          var slidesHtml = reviews
            .map(function (r) {
              return (
                '<div class="swiper-slide ugc-r__slide">' +
                '<div class="ugc-r__card">' +
                '<img class="ugc-r__img" src="' +
                escapeAttr(r.image) +
                '" alt="" loading="lazy" width="600" height="800" sizes="(max-width: 749px) 85vw, 28vw"/>' +
                '</div></div>'
              );
            })
            .join('');
          wrapper.innerHTML = slidesHtml;
          runSwiper();
        })
        .catch(function () {
          return undefined;
        });
      return;
    }

    var domSlides = wrapper.querySelectorAll('.ugc-r__slide');
    if (domSlides.length) {
      reviews = Array.prototype.map.call(domSlides, function (slide) {
        var rating = parseInt(slide.getAttribute('data-review-rating'), 10);
        return {
          name: slide.getAttribute('data-review-name') || 'Customer',
          text: slide.getAttribute('data-review-text') || '',
          rating: Math.min(5, Math.max(1, rating || 5)),
          initial: (slide.getAttribute('data-review-initial') || 'C').charAt(0),
        };
      });
    } else if (elScript) {
      try {
        reviews = JSON.parse(elScript.textContent.trim() || '[]') || [];
      } catch (e) {
        reviews = [];
      }
    }
    if (!reviews.length) return;
    runSwiper();
  }

  function start() {
    var all = document.querySelectorAll('.ugc-r');
    for (var i = 0; i < all.length; i += 1) {
      mount(all[i]);
    }
  }

  if (typeof window.Swiper !== 'undefined') {
    start();
    return;
  }
  var attempts = 0;
  var wait = setInterval(function () {
    attempts += 1;
    if (typeof window.Swiper !== 'undefined') {
      clearInterval(wait);
      start();
    } else if (attempts > 40) {
      clearInterval(wait);
    }
  }, 25);
})();
